export default "__VITE_ASSET__Dzg7KiCv__"